import React, { ReactNode } from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';

interface CardsProps extends FlexProps {
  children: ReactNode;
}

export const Card: React.FC<CardsProps> = ({ children, ...props }) => {
  return (
    <Flex
      minW={props.minW ?? 293}
      minH={props.minH ?? 136}
      flexDir="column"
      justifyContent="center"
      bg="white"
      boxShadow="0px 2px 2px rgba(0, 0, 0, 0.1)"
      border="1px solid"
      borderColor="gray.1000"
      borderRadius={4}
      py="12px"
      px={4}
      {...props}
    >
      {children}
    </Flex>
  );
};
